<template>
  <div>
    <b-form @submit.prevent="onLoginSubmit">
      <b-form-group id="emailLoginInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-envelope-o fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="emailLoginInput"
            name="user.email"
            type="email"
            maxlength="255"
            v-model.trim="user.email"
            v-validate="'required|email'"
            :state="!errors.has('user.email')"
            aria-describedby="emailLoginLiveFeedback"
            placeholder="Adresse e-mail"
            data-vv-as="&quot;Adresse e-mail&quot;"
            data-vv-scope="login"
            size="lg"
          />
          <b-form-invalid-feedback
            id="emailLoginLiveFeedback"
            v-if="errors.has('login.user.email')"
          >{{ errors.first('login.user.email') }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group id="passwordLoginInputGroup">
        <b-input-group>
          <b-input-group-prepend is-text>
            <i class="fa fa-key fa-lg fa-fw"></i>
          </b-input-group-prepend>
          <b-form-input
            id="passwordLoginInput"
            name="user.password"
            type="password"
            maxlength="255"
            v-model="user.password"
            v-validate="{required: true, min:8}"
            :state="!errors.has('user.password')"
            aria-describedby="passwordLoginLiveFeedback passwordLoginLiveHelp"
            placeholder="Mot de passe"
            data-vv-as="&quot;Mot de passe&quot;"
            data-vv-scope="login"
            size="lg"
          />
          <b-form-invalid-feedback
            id="passwordLoginLiveFeedback"
            v-if="errors.has('login.user.password')"
          >{{ errors.first('login.user.password') }}</b-form-invalid-feedback>
        </b-input-group>
        <b-form-text id="passwordLoginLiveHelp">
          <a
            href="#"
            title="Mot de passe oublié ?"
            @click="showModalPasswordReset=true"
          >Mot de passe oublié ?</a>
        </b-form-text>
      </b-form-group>
      <b-button type="submit" variant="primary" size="lg" :disabled="status.loggingIn">
        Connexion
        <i class="fa fa-sign-in fa-lg fa-fw"></i>
      </b-button>
      <i v-show="status.loggingIn" class="loader fa fa-spinner fa-spin fa-2x"></i>
      <a class="btn btn-block btn-social btn-facebook" @click="authWithFB">
        <span class="fa fa-facebook"></span>
        Connexion avec Facebook
      </a>
      <a class="btn btn-block btn-social btn-google" @click="authWithGoogle">
        <span class="fa fa-google"></span>
        Connexion avec Google
      </a>
    </b-form>
    <b-modal
      ref="modalPasswordReset"
      v-model="showModalPasswordReset"
      title="Mot de passe oublié"
      lazy
      centered
      hide-footer
    >
      <p>Entrez l'adresse email avec laquelle vous vous êtes inscrit pour recevoir le lien de réinitialisation de votre mot de passe.</p>
      <b-form @submit.prevent="onPasswordResetSubmit">
        <b-form-group id="emailPasswordResetInputGroup">
          <b-input-group>
            <b-input-group-prepend is-text>
              <i class="fa fa-envelope-o fa-lg fa-fw"></i>
            </b-input-group-prepend>
            <b-form-input
              id="emailPasswordResetInput"
              name="user.email"
              type="email"
              maxlength="255"
              v-model.trim="user.email"
              v-validate="'required|email'"
              :state="!errors.has('user.email')"
              aria-describedby="emailPasswordResetLiveFeedback"
              placeholder="Adresse e-mail"
              data-vv-as="&quot;Adresse e-mail&quot;"
              data-vv-scope="passwordReset"
              size="lg"
            />
            <b-form-invalid-feedback
              id="emailPasswordResetLiveFeedback"
              v-if="errors.has('passwordReset.user.email')"
            >{{ errors.first('passwordReset.user.email') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-button type="submit" variant="primary" size="lg">Envoyer</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "UserLogin",
  data() {
    return {
      showModalPasswordReset: false
    };
  },
  computed: {
    ...mapState("account", ["status", "user"])
  },
  methods: {
    ...mapActions("account", [
      "login",
      "authWithFB",
      "authWithGoogle",
      "passwordReset"
    ]),
    onLoginSubmit() {
      this.$validator.validateAll("login").then(valid => {
        if (valid) {
          this.login(this.user);
        }
      });
    },
    onPasswordResetSubmit() {
      this.$validator.validateAll("passwordReset").then(valid => {
        if (valid) {
          this.passwordReset(this.user.email);
        }
      });
    }
  }
};
</script>
